// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_tableSelic__2UjJu th,
.styles_tableSelic__2UjJu td {
  text-align: center !important;
}

.styles_tableSelic__2UjJu th div {
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AtualizarSelic/styles.module.css"],"names":[],"mappings":"AAAA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".tableSelic th,\n.tableSelic td {\n  text-align: center !important;\n}\n\n.tableSelic th div {\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableSelic": `styles_tableSelic__2UjJu`
};
export default ___CSS_LOADER_EXPORT___;
